export default __webpack_public_path__ + "static/media/jamScene.8d757695.png";